import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./ImageContainer.module.scss";

interface ImageContainerProps {
  src: string;
  alt: string;
  translateAlt?: boolean;
}

const ImageContainer: React.FC<ImageContainerProps> = ({
  src,
  alt,
  translateAlt = false,
}) => {
  const { t } = useTranslation("common");

  const displayAlt = translateAlt ? t(alt) : alt;

  return (
    <div className={styles.imageWrapper}>
      <img src={src} alt={displayAlt} className={styles.image} />
      <div className={styles.gradOverlayBot}></div>
    </div>
  );
};

export default ImageContainer;
